import { render, staticRenderFns } from "./EntityPageHeader.vue?vue&type=template&id=34442aac&scoped=true&"
import script from "./EntityPageHeader.vue?vue&type=script&lang=js&"
export * from "./EntityPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./EntityPageHeader.vue?vue&type=style&index=0&id=34442aac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34442aac",
  null
  
)

export default component.exports